<template>
  <div id="form-creation-view">
    <h1 id="form-name">
      {{ form.name }}
    </h1>
    <p id="form-description" v-if="form.description">
      {{ form.description }}
    </p>
    <div class="form-item" v-for="(field, index) in form.fields" :key="index">
      <form-item :item="field" />
      <round-button-with-icon
        icon="pencil"
        @click="beginEditField(field, index)"
      />
      <round-button-with-icon icon="x" @click="deleteField(index)" />
    </div>
    <Button class="scs-button" text="Add Field" @click="addField" />
  </div>
</template>
<script>
import FormItem from "@/Components/UI/FormItem.vue";
import Button from "@/Components/UI/Button.vue";
import RoundButtonWithIcon from "@/Components/UI/RoundButtonWithIcon.vue";
export default {
  methods: {
    addField() {
      this.$emit("initialize-field");
    },
    deleteField(index) {
      this.$emit("delete-field", index);
    },
    beginEditField(field, index) {
      this.$emit("initialize-edit-field", { field: field, index: index });
    },
  },
  components: {
    FormItem,
    Button,
    RoundButtonWithIcon,
  },
  emits: ["initialize-field", "initialize-edit-field", "delete-field"],
  props: ["form"],
};
</script>
<style scoped>
@media screen {
  #form-creation-view {
    min-height: 350px;
    max-height: 500px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: left;
    padding-bottom: 30px;
  }

  h1,
  p {
    margin: 7px;
    text-align: right;
  }

  .form-item {
    display: flex;
    align-items: center;
  }

  .scs-button {
    margin: 20px 0;
  }
  @media (min-width: 800px) {
    .form-item {
      display: flex;
      align-items: center;
    }

    .scs-button {
      margin: 20px 0;
    }
  }
}
@media screen {
  @media (min-width: 800px) {
  }
}
</style>
